<template>
  <div data-type="input" class="input">
    <PreviewImage v-if="showImageLoader" :input-name="inputName" />

    <input
      :id="inputId"
      type="text"
      autocomplete="off"
      :class="{ 'invalid': $v.$error }"
      :placeholder="inputPlaceholder"
      :size="inputSize"
      :title="inputTitle"
      :disabled="disabled"
      :value="value"
      :readonly="readonly"
      @input="handleInput"
    />

    <label :for="inputId" :class="{ 'hinted': capustaInfo }">
      <span>{{ inputName }}</span>
      <span v-if="isCounter(this.showCounter, this.maxLength, this.value)">
        {{ getCounter(this.maxLength, this.value) }}
      </span>

      <span v-if="capustaInfo" class="hint" @click.prevent="$emit('showInfo')"></span>

      <span v-if="readonly" class="lock"><mark></mark></span>
      <span v-if="$v.$error" class="validation" :title="getValidationInfo($v)"><mark></mark></span>
    </label>

    <slot name="link"></slot>
  </div>
</template>

<script>
import { requiredIf, minLength, maxLength } from 'vuelidate/lib/validators';
import { isUrlOrIframe } from './CustomValidators';

import PreviewImage from '@/components/inputElements/PreviewImage';
import { getCounter, isCounter, getValidationInfo } from '@/services/inputMixins';

export default {
  name: 'InputLink',
  mixins: [
    getCounter,
    isCounter,
    getValidationInfo,
  ],
  components: {
    PreviewImage,
  },
  props: {
    value: [
      Number,
      String,
    ],
    inputName: String,
    inputTitle: String,
    inputPlaceholder: String,
    inputId: String,
    disabled: Boolean,
    readonly: Boolean,
    capustaInfo: String,
    inputSize: {
      type: String,
      default() {
        return '12';
      },
    },
    minLength: {
      type: Number,
      default() {
        return 0;
      },
    },
    maxLength: {
      type: Number,
      default() {
        return 2510;
      },
    },
    required: {
      type: Boolean,
      default() {
        return true;
      },
    },
    showCounter: {
      type: Boolean,
      default() {
        return true;
      },
    },
    showImageLoader: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  validations() {
    return {
      value: {
        required: requiredIf(() => this.required),
        minLength: minLength(this.minLength),
        maxLength: maxLength(this.maxLength),
        isUrlOrIframe,
      },
    };
  },
  methods: {
    handleInput(e) {
      this.$emit('input', e.target.value.trim());
      this.$v.$touch();
    },
  },
};
</script>

<style lang="sass" scoped>
  .hinted
    span
      &.hint
        display: block
        width: calc(1rem * 1.44)
        margin: 0 0.12rem 0 calc(0.12rem + 0.64rem)
        cursor: help

        &:not(:last-child)
          margin-right: 3px !important

        &::after
          content: '?'
          width: calc(1rem * 1.44)
          position: absolute
          top: -0.12rem
          right: 0
          font-size: 1rem
          font-weight: 800
          text-align: center
          color: #93939D
          border: 0.12rem solid #93939D
          border-radius: 50%
          box-sizing: content-box
</style>
